"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WidgetSelectorButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WidgetSelectorButton = function WidgetSelectorButton(_ref) {
  var onClick = _ref.onClick,
      type = _ref.type;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var PreviewIcon = (0, _nicbaseReducers.widgetTypeToIcon)(type.id) || _nicbaseIcons.Help;

  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      return setIsHovered(true);
    },
    onMouseOut: function onMouseOut() {
      return setIsHovered(false);
    },
    onFocus: function onFocus() {
      return setIsHovered(true);
    },
    onBlur: function onBlur() {
      return setIsHovered(false);
    },
    className: "relative inline-block mt-4 mx-3 cursor-pointer pb-6 select-none leading-tight focus:outline-none"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-40 max-h-40 shadow rounded"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center h-40"
  }, /*#__PURE__*/_react["default"].createElement(PreviewIcon, {
    className: "w-20 h-20"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute rounded w-40 h-40 opacity-0 top-0', {
      'bg-black bg-opacity-80 opacity-100 transition-opacity duration-300 ease-in': isHovered
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex items-center justify-center px-2 h-full w-full overflow-hidden text-center text-white text-sm"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: type.description
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('pt-2 flex items-start justify-center text-center text-primary text-sm', {
      'justify-between items-center mx-1': isHovered
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])({
      'text-left font-bold': isHovered
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: type.typeName
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.PlusInverted, {
    className: (0, _classnames["default"])('w-3 h-3', {
      hidden: !isHovered
    })
  }))));
};

exports.WidgetSelectorButton = WidgetSelectorButton;
WidgetSelectorButton.propTypes = {
  type: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    typeName: _propTypes["default"].string,
    description: _propTypes["default"].string
  }),
  onClick: _propTypes["default"].func
};
WidgetSelectorButton.defaultProps = {
  type: _propTypes["default"].shape({}),
  onClick: _propTypes["default"].func
};
var _default = WidgetSelectorButton;
exports["default"] = _default;